import type { FileViewerRenderer } from '../types.js';
import { PdfRenderer } from './PdfRenderer.js';
import { ImageRenderer } from './ImageRenderer.js';
import { VideoRenderer } from './VideoRenderer.js';
import { AudioRenderer } from './AudioRenderer.js';
import { TextRenderer } from './TextRenderer.js';
import { UnsupportedRenderer } from './UnsupportedRenderer.js';

/** The built-in renderers, tried in order after any the host registered. */
export const BUILTIN_RENDERERS: FileViewerRenderer[] = [
  { id: 'pdf', match: (d) => d.family === 'pdf', component: PdfRenderer },
  // SVG is an image to look at and text to read; the picture wins, the Preview toggle in text mode is the other way in.
  { id: 'image', match: (d) => d.family === 'image', component: ImageRenderer },
  { id: 'video', match: (d) => d.family === 'video', component: VideoRenderer },
  { id: 'audio', match: (d) => d.family === 'audio', component: AudioRenderer },
  { id: 'text', match: (d) => d.family === 'code' || d.family === 'text', component: TextRenderer },
  { id: 'unsupported', match: () => true, component: UnsupportedRenderer }
];

export { PdfRenderer, ImageRenderer, VideoRenderer, AudioRenderer, TextRenderer, UnsupportedRenderer };
